// QR_Value er altid en uigennemsigtig kode. Kun disse koder/ældre aliaser kan
// oversættes til interne destinationsstier; rå URL'er må aldrig navigeres til.
const QR_DESTINATIONS = [
  { code: "brochure", aliases: ["BROCHURE"], path: "/#brochure" },
  { code: "brochure-download", aliases: ["BROCHURE-DOWNLOAD"], path: "/#brochure" },
  { code: "how-it-works", aliases: ["HOW-IT-WORKS"], path: "/#saadan" },
  { code: "tyre-amount", aliases: ["TYRE-AMOUNT", "/dk/hvor-meget-skal-mit-daek"], path: "/hvor-meget-skal-mit-daek" },
  { code: "tyre-photo", aliases: ["TYRE-PHOTO"], path: "/hvor-meget-skal-mit-daek" },
  { code: "paafyldning-metalpumpe", aliases: ["METAL-PUMP", "/paafyldning-metalpumpe"], path: "/paafyldning-metalpumpe" },
  { code: "paafyldning-plastpumpe", aliases: ["PLASTIC-PUMP", "/paafyldning-plastpumpe"], path: "/paafyldning-plastpumpe" },
  { code: "msds", aliases: ["MSDS", "/msds"], path: "/msds" },
];

const normaliseQrValue = (value) => String(value || "").trim().toUpperCase();

export const evaluateQrValue = (value) => {
  const wanted = normaliseQrValue(value);
  const match = QR_DESTINATIONS.find((entry) => entry.aliases.some((alias) => normaliseQrValue(alias) === wanted));
  return match ? { code: match.code, path: match.path } : { code: "None", path: "" };
};

export const qrPathForCode = (code) => QR_DESTINATIONS.find((entry) => entry.code === code)?.path || "";